import { Injectable } from '@angular/core';
import { ProfileSelectorColumnMetaDataDto } from './dto/profile-selector-column-meta-data.dto';
import { ProfileSelectorConfigDto } from './dto/profile-selector-config.dto';
import { ProfileSelectorFieldTypeEnum } from './dto/profile-selector-field-type.enum';
import { ProfileSelectorColumnDataTypeEnum } from './dto/profile-selector-column-data-types.enum';
import { ProfileSelectorFieldEnum } from './dto/profile-selector-field.enum';

@Injectable({
  providedIn: 'root',
})
export class ProfileSelectorColumnMetadataService {
  constructor() {}

  public buildColumnMetaData(config: ProfileSelectorConfigDto): Array<ProfileSelectorColumnMetaDataDto> {
    let columnMetaData = new Array<ProfileSelectorColumnMetaDataDto>();
    config.SelectedFields.forEach((field) => {
      // Don't add hardcoded profile name column
      if (field.StandardFieldId != ProfileSelectorFieldEnum.ProfileName) {
        let columnData = { ProfileSelectorFieldTypeEnum: field.FieldTypeEnum } as ProfileSelectorColumnMetaDataDto;
        switch (field.FieldTypeEnum) {
          case ProfileSelectorFieldTypeEnum.StandardField:
            columnData.DataType = this.buildStandardTypeMetaData(field.StandardFieldId);
            break;
          case ProfileSelectorFieldTypeEnum.AffCode:
            columnData.DataType = ProfileSelectorColumnDataTypeEnum.Boolean;
            break;
          case ProfileSelectorFieldTypeEnum.AffCodeType:
            columnData.DataType = ProfileSelectorColumnDataTypeEnum.String;
            break;
          case ProfileSelectorFieldTypeEnum.CustomField:
            columnData.DataType = ProfileSelectorColumnDataTypeEnum.String;
            break;
        }
        columnMetaData.push(columnData);
      }
    });

    return columnMetaData;
  }
  private buildStandardTypeMetaData(fieldId: ProfileSelectorFieldEnum): ProfileSelectorColumnDataTypeEnum {
    switch (fieldId) {
      case ProfileSelectorFieldEnum.OrgIndicator:
      case ProfileSelectorFieldEnum.Member:
      case ProfileSelectorFieldEnum.Inactive:
      case ProfileSelectorFieldEnum.ReceivesCommunication:
        return ProfileSelectorColumnDataTypeEnum.Boolean;
      case ProfileSelectorFieldEnum.LastLoginDate:
      case ProfileSelectorFieldEnum.LastContactDate:
      case ProfileSelectorFieldEnum.LastContactType:
      case ProfileSelectorFieldEnum.MemberSince:
      case ProfileSelectorFieldEnum.DuesDatePaid:
        return ProfileSelectorColumnDataTypeEnum.Date;
      case ProfileSelectorFieldEnum.Email:
      case ProfileSelectorFieldEnum.MainProfileEmail:
        return ProfileSelectorColumnDataTypeEnum.Email;
      case ProfileSelectorFieldEnum.NoEmail:
        return ProfileSelectorColumnDataTypeEnum.SubscriptionStatus;
      default:
        return ProfileSelectorColumnDataTypeEnum.String;
    }
  }
}
